export default {"src":"/_next/static/image/public/images/ic_star_filled_grey.5f2dd5163f64ec93cbb16d9f7ff05ad9.svg","height":29,"width":30};